import styled from '@emotion/styled';
import { spacing } from '@naf/theme';

export const Wrapper = styled.div`
  grid-area: filter;
  display: flex;
  flex-direction: column;
  gap: ${spacing.space32};
`;
